import React from 'react';
import { processSteps } from '../data/mock';

const ProcessSection = () => {
  return (
    <section id="process" className="py-24 bg-neutral-50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-brand/5 to-transparent" />
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-brand/5 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-brand font-semibold text-sm tracking-wider uppercase mb-4 block">
            How It Works
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-6">
            Our Proven 3-Step Process
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto">
            From initial contact to tailored treatment, we follow a systematic
            approach to deliver effective, lasting results.
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-brand/30 to-transparent" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {processSteps.map((item, index) => (
              <div key={item.step} className="relative h-full">
                {/* Step Card */}
                <div className="bg-white border border-neutral-200 rounded-2xl p-6 text-center hover:border-brand/30 hover:shadow-lg transition-all duration-300 group h-full flex flex-col">
                  {/* Step Number */}
                  <div className="relative mb-6">
                    <div className="w-16 h-16 mx-auto bg-white border-2 border-brand rounded-full flex items-center justify-center group-hover:bg-brand transition-colors duration-300">
                      <span className="text-2xl font-bold text-brand group-hover:text-white transition-colors duration-300">
                        {item.step}
                      </span>
                    </div>
                    {/* Arrow for desktop */}
                    {index < processSteps.length - 1 && (
                      <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-brand/30" />
                    )}
                  </div>

                  <h3 className="text-lg font-semibold text-neutral-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-neutral-600 text-sm leading-relaxed flex-1">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
